import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/stockOut',
    name: 'stockOut',
    meta,
    redirect: { name: 'stockOut' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'stockOut4SalesList',
            name: `${pre}StockOut4SalesList`,
            component: _import('stockOut/stockOut4SalesList'),
            meta: {
                ...meta,
                title: '销售出库记录'
            }
        },
        {
            path: 'stockOut4OtherList',
            name: `${pre}stockOut4OtherList`,
            component: _import('stockOut/stockOut4OtherList'),
            meta: {
                ...meta,
                title: '其它出库记录'
            }
        },
    ])('stockOut-')
}
